/* The cloned FAQ keeps the original GemPages markup and single-open behavior. */
(function () {
  function setIcon(root, header, open) {
    var icon = header.querySelector('.gp-collapsible-icon');
    if (!icon) return;
    try {
      var settings = JSON.parse(root.getAttribute('gp-data') || '{}').setting || {};
      icon.innerHTML = open ? (settings.iconExpand || '') : (settings.iconCollapse || '');
    } catch (_) {}
  }

  function close(item, root) {
    var body = item.querySelector('.gp-accordion-item_body');
    var header = item.querySelector('.gp-accordion-item_header');
    if (!body || !header) return;
    body.style.maxHeight = body.scrollHeight + 'px';
    body.offsetHeight;
    body.style.gridTemplateRows = '0fr';
    body.style.maxHeight = '0px';
    body.dataset.show = 'false';
    header.setAttribute('aria-expanded', 'false');
    setIcon(root, header, false);
  }

  document.addEventListener('click', function (event) {
    var header = event.target.closest('.gp-accordion-item_header');
    if (!header) return;
    var item = header.closest('.gp-accordion-item');
    var root = header.closest('gp-accordion');
    var body = item && item.querySelector('.gp-accordion-item_body');
    if (!item || !root || !body) return;

    event.preventDefault();
    var opening = body.dataset.show !== 'true';
    root.querySelectorAll('.gp-accordion-item').forEach(function (other) { close(other, root); });
    if (!opening) return;

    body.style.gridTemplateRows = 'unset';
    body.style.maxHeight = body.scrollHeight + 'px';
    body.dataset.show = 'true';
    header.setAttribute('aria-expanded', 'true');
    setIcon(root, header, true);
  });
})();
